import { createContext, useContext, useState } from "react";

const DevopstrioAuthContext = createContext();

export const DevopstrioAuthProvider = ({ children }) => {
  const [devopstrioUser, setDevopstrioUser] = useState(() => {
    const stored = localStorage.getItem("devopstrio_auth");
    return stored ? JSON.parse(stored) : null;
  });

  const login = (token, user) => {
    const data = { token, user };
    localStorage.setItem("devopstrio_auth", JSON.stringify(data));
    setDevopstrioUser(data);
  };

  const logout = () => {
    localStorage.removeItem("devopstrio_auth");
    setDevopstrioUser(null);
  };

  return (
    <DevopstrioAuthContext.Provider
      value={{ devopstrioUser, login, logout }}
    >
      {children}
    </DevopstrioAuthContext.Provider>
  );
};

export const useDevopstrioAuth = () => useContext(DevopstrioAuthContext);
